import { authorizeGetRequest, authorizePostRequest } from "api";
import {
  IDriverLocationResponse,
  IPassengerLocationResponse,
  IDiagnoseDriverResponse,
  IResetDriverLocationResponse,
  IResetDriverLocationInput,
} from "models/location";

export const getDriverLocationApi = (driverId: string) => {
  return authorizeGetRequest<IDriverLocationResponse>(
    `locations/${driverId}/driver`
  );
};

export const getPassengerLocationApi = (passengerId: string) => {
  return authorizeGetRequest<IPassengerLocationResponse>(
    `locations/${passengerId}/passenger`
  );
};

// Stuck Driver Management APIs
export const diagnoseDriverApi = (driverId: string) => {
  return authorizeGetRequest<IDiagnoseDriverResponse>(
    `locations/admin/diagnose-driver?driver-id=${driverId}`
  );
};

export const resetDriverLocationApi = (input: IResetDriverLocationInput) => {
  const params = new URLSearchParams();
  params.append("driver-id", input.driver_id);
  params.append("latitude", input.latitude.toString());
  params.append("longitude", input.longitude.toString());
  if (input.heading !== undefined) {
    params.append("heading", input.heading.toString());
  }

  return authorizePostRequest<IResetDriverLocationResponse>(
    `locations/admin/reset-driver-location?${params.toString()}`,
    {} // Empty data object for POST request
  );
};

export const autoCleanupStuckDriversApi = (thresholdMinutes?: number, dryRun: boolean = false) => {
  const params = new URLSearchParams();
  if (thresholdMinutes) params.append("threshold_minutes", thresholdMinutes.toString());
  params.append("dry_run", dryRun.toString());

  return authorizePostRequest<any>(
    `locations/admin/auto-cleanup-stuck-drivers?${params.toString()}`,
    {}
  );
};
